import { useParams } from 'react-router'

interface VariantRouteParams {
    estate: string;
    variant: string;
}

export default function useVariantParams() {
    const { estate, variant } = useParams<VariantRouteParams>()

    return {
        estate,
        variantId: variant ? parseInt(variant, 10) : undefined,
    }
}
